// import { findDOMNode } from 'react-dom';

export const pageSectionsSource = {
  beginDrag(props) {
    props.setDragging(true);
    return {
      id: props.id,
      index: props.index,
      sectionType: props.section ? props.section.section : null,
    };
  },

  endDrag(props) {
    props.setDragging(false);
  },

  canDrag(props) {
    return props.canDrag;
  },
};

export const pageSectionsTarget = {
  hover(props, monitor/* component */) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Determine rectangle on screen
    /* eslint-disable react/no-find-dom-node */
    // const node = findDOMNode(component);
    // const hoverBoundingRect = node.getBoundingClientRect();
    /* eslint-enable */

    // Get vertical middle
    // const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    // const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Get the container
    const container = document.getElementsByClassName('main-content')[0];

    // Scroll the container up
    if (clientOffset.y < container.offsetTop + 50) {
      container.scrollBy(0, -5);
    }
    // Scroll the container down
    if (clientOffset.y > container.offsetTop + container.offsetHeight - 50) {
      container.scrollBy(0, 5);
    }

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    /*
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }
    */

    // Dragging upwards
    /*
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }
    */

    // Time to actually perform the action
    props.moveSection(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    /* eslint-disable no-param-reassign */
    // monitor.getItem().index = hoverIndex;
    /* eslint-enable */
  },
};
